const EditSpecialFund = () => import('../modules/xmsb/energy/operators/EditSpecialFundGzl')

export default [
  {

    path: '/specialedit',
    name: 'specialedit',
    component: EditSpecialFund,
    meta: {
      title: '三位一体资金申报编辑',
      fullscreen: true,
    },
  },
]
